import type { TemplateVarsData } from 'types/templates/templates-menu';

/** נרמול סוגריים "מלאים" (Unicode) לסוגרי ASCII — כדי ש־regex יתאים לתבניות מהשרת */
function normalizeBraceChars(text: string): string {
  return text.replace(/\uFF5B/g, '{').replace(/\uFF5D/g, '}');
}

/**
 * מחליף placeholders בטקסט תבנית (תצוגה מקדימה וכו').
 * סדר קבוע: קודם `{{n}}` (Meta), אחר כך `{n}` (legacy).
 * אם מריצים רק את `{n}` על מחרוזת `{{1}}`, ה־regex מתאים ל־`{1}` הפנימי ונשאר `{ערך}`.
 */
export function substituteTemplatePlaceholders(
  text: string | null | undefined,
  varsData: TemplateVarsData | undefined,
  role: 'body' | 'footer' | 'header',
): string {
  if (!text) return '';
  let t = normalizeBraceChars(text);

  const lookup = (n: number): string | undefined => {
    const key =
      role === 'header' ? `header_${n}` : role === 'footer' ? `footer_${n}` : `body_${n}`;
    const param = varsData?.find((p) => p.name === key);
    return param?.text && param.text !== '' ? param.text : undefined;
  };

  t = t.replace(/\{\{\s*(\d+)\s*\}\}/g, (_full, nStr) => {
    const n = parseInt(nStr, 10);
    const v = lookup(n);
    return v !== undefined ? v : `{{${n}}}`;
  });

  t = t.replace(/\{(\d+)\}/g, (_full, nStr) => {
    const n = parseInt(nStr, 10);
    const v = lookup(n);
    return v !== undefined ? v : `{${n}}`;
  });

  return t;
}
